import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-gestao-background text-slate-800">
      <SiteHeader />
      <main className="pt-24 pb-16 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto prose prose-slate prose-headings:text-gestao-primary">
          <h1 className="text-3xl font-bold mb-8">Política de Privacidade</h1>
          <p className="text-slate-600 text-sm mb-8">
            Última atualização: {new Date().toLocaleDateString('pt-PT')}
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Responsável pelo tratamento</h2>
            <p>
              O responsável pelo tratamento dos dados pessoais é a <strong>Electro Salir Lda.</strong>, NIF 502 529 962, com sede em Rua Manuel Dourado Eusébio N.º 34 A, Salir, 8100-202 Portugal. Contactos: 289 489 848, 917 869 307, electrosalir@sapo.pt.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">2. Dados pessoais recolhidos</h2>
            <p>
              A Electro Salir Lda. pode recolher dados que o utilizador facultar voluntariamente através do website ou por telefone/e-mail, designadamente: nome, morada, telefone, endereço de correio eletrónico e outras informações necessárias para orçamentos, prestação de serviços ou resposta a contactos.
            </p>
            <p className="mt-2">
              O acesso ao site pode ainda implicar a recolha automática de dados técnicos (endereço IP, tipo de navegador, páginas visitadas) para fins de funcionamento e segurança do site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">3. Finalidades do tratamento</h2>
            <p>
              Os dados pessoais são tratados para: gestão de pedidos de orçamento e de contactos; prestação de serviços de climatização, ar condicionado e painéis solares; cumprimento de obrigações legais e contratuais; e, quando aplicável, envio de informações comerciais com o seu consentimento.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">4. Base legal</h2>
            <p>
              O tratamento assenta na execução de contrato ou medidas pré-contratuais (pedidos de orçamento e serviços), no consentimento do titular, quando aplicável, e no legítimo interesse da Electro Salir Lda. para a gestão da relação comercial e do website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">5. Conservação dos dados</h2>
            <p>
              Os dados são conservados durante o tempo necessário às finalidades referidas e para cumprimento de obrigações legais (nomeadamente fiscais e contratuais). Findo esse período, serão eliminados ou anonimizados.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">6. Partilha de dados</h2>
            <p>
              A Electro Salir Lda. não vende nem cede os seus dados pessoais a terceiros para fins de marketing. Os dados podem ser comunicados a entidades que prestem serviços à Electro Salir Lda. (por exemplo, alojamento do site ou gestão de correio), sempre no estrito cumprimento da lei e com garantias de confidencialidade.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">7. Direitos do titular</h2>
            <p>
              Nos termos do Regulamento Geral de Proteção de Dados (RGPD), o titular dos dados tem direito a: acesso, retificação, apagamento, limitação do tratamento, portabilidade e oposição ao tratamento. Pode ainda apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD). Para exercer estes direitos, contacte a Electro Salir Lda. pelos meios indicados no ponto 1.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">8. Segurança</h2>
            <p>
              A Electro Salir Lda. adota medidas técnicas e organizativas adequadas para proteger os dados pessoais contra acesso não autorizado, perda ou alteração.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">9. Alterações</h2>
            <p>
              Esta Política de Privacidade pode ser alterada. A data da última atualização consta no topo da página. Recomenda-se a sua leitura periódica.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">10. Contactos</h2>
            <p>
              Para questões sobre o tratamento dos seus dados pessoais, contacte a Electro Salir Lda. (NIF 502 529 962): Rua Manuel Dourado Eusébio N.º 34 A, Salir, 8100-202 Portugal; tel. 289 489 848; tlm. 917 869 307; e-mail electrosalir@sapo.pt.
            </p>
          </section>

          <p className="mt-12">
            <Link to="/" className="text-gestao-primary font-semibold hover:underline">
              ← Voltar ao início
            </Link>
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
